import React, { Component } from 'react';

export default class DisplayJob extends Component {
    constructor(props) {
        super(props);

        this.state = {
            job_notes: null,
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        console.log('get request will receive props', nextProps.job);
        this.getPreviousJobNote(nextProps.job);
    }

    componentDidMount() {
        console.log('get request did mount');
        this.getPreviousJobNote(this.props.job);
    }

    getPreviousJobNote = (job) => {
        axios
            .get(`/jobs/${job.id}/previous-job`)
            .then((res) => {
                console.log(res);
                this.setState({
                    job_notes: res.data,
                });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    render() {
        let job = this.props.job;
        return (
            <div className="col-12 mt-5">
                <div className="job-details p-3">
                    <div className="row">
                        <div className="col-md-12">
                            <h4 className="text-center mb-2 p-1 bg-cw-gprimary">Job details</h4>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <p>
                                <b>Id: </b>
                                {job.id}
                            </p>
                        </div>
                        <div className="col-md-4">
                            <p>
                                <b>On site contact mobile: </b> {job.os_contact_mobile ? job.os_contact_mobile : 'None'}
                            </p>
                        </div>
                        <div className="col-md-4">
                            <p>
                                <b>On site contact name: </b> {job.os_contact_name ? job.os_contact_name : 'None'}
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <p>
                                <b>Address line 1: </b> {job.address_line_1}
                            </p>
                        </div>
                        <div className="col-md-4">
                            <p>
                                <b>Postcode: </b> {job.postcode}
                            </p>
                        </div>
                        <div className="col-md-4">
                            <p>
                                <b>City: </b> {job.city}
                            </p>
                        </div>
                    </div>
                    <div className="row"></div>
                    <div className="row">
                        <div className="col-md-4">
                            <p>
                                <b>Job type: </b> {job.job_type.name}
                            </p>
                        </div>
                        <div className="col-md-4">
                            <p>
                                <b>Job description: </b> {job.description ? job.description : 'No description'}
                            </p>
                        </div>
                        <div className="col-md-4">
                            <p>
                                <b>Admin notes:</b> {job.admin_notes ? job.admin_notes : 'No note'}
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <p>
                                <b>Previous job notes: </b> {this.state.job_notes}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
